import React from "react";

const MultiPrescriptionCOntext = React.createContext();

export default MultiPrescriptionCOntext;
